import axios from './axiosInstances/axiosInstance';

export const getBasketUpsell = (basketId) => {
  return axios.get(`/baskets/${basketId}/upsell`);
};
